var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#28A48F",
  fillRule: "nonzero",
  d: "m6.02 10.22 4.935-4.935-.98-.98L6.02 8.26 4.025 6.265l-.98.98zM7 0q1.452 0 2.73.551a7.1 7.1 0 0 1 2.223 1.496q.944.945 1.496 2.223.55 1.278.551 2.73 0 1.452-.551 2.73a7.1 7.1 0 0 1-1.496 2.223 7.1 7.1 0 0 1-2.223 1.496A6.8 6.8 0 0 1 7 14a6.8 6.8 0 0 1-2.73-.551 7.1 7.1 0 0 1-2.222-1.496A7.1 7.1 0 0 1 .55 9.73 6.8 6.8 0 0 1 0 7q0-1.452.551-2.73a7.1 7.1 0 0 1 1.496-2.222A7.1 7.1 0 0 1 4.27.55 6.8 6.8 0 0 1 7 0"
})));
export default __webpack_public_path__ + "static/media/green-tick.d17d7552.svg";
export { SvgComponent as ReactComponent };